import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import AdminPanelSidebarNavigation from './Sidebar/Navigation';

import {
  defaultLogoUrl,
  defaultShareLogoUrl,
} from '../../helpers/Settings';

class AdminPanelSidebar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sidebarActive: false,
    };
  }

  toggleSidebar() {
    this.setState(prevState => ({ sidebarActive: !prevState.sidebarActive }));
  }

  render() {
    const { sidebarActive } = this.state;
    const {
      intl,
      profile,
      version,
    } = this.props;

    return (
      <>
        <AdminPanelSidebarNavigation />
        <nav className="sidebar">
          <header className="sidebar-header">
            <NavbarBrand tag={Link} to="/" className="mr-0">
              <img src={profile.client.logo_url || defaultLogoUrl} alt={profile.client.name} className="logo" />
              <img src={profile.client.share_logo_url || defaultShareLogoUrl} alt={profile.client.name} className="logo-alt" />
            </NavbarBrand>
            <button type="button" className="navbar-toggler" onClick={() => this.toggleSidebar()} aria-label={sidebarActive ? intl.formatMessage({ defaultMessage: 'Close menu' }) : intl.formatMessage({ defaultMessage: 'Open menu' })}>
              <i className="fas fa-bars" />
            </button>
          </header>

          <div className={classnames('sidebar-nav', { active: sidebarActive })}>
            <TabContent activeTab="1" className="nav-tab-content">
              <TabPane tabId="1" className="tab-start">
                <Nav tag="div" className="ml-auto nav-main">
                  <div className="sidebar-core-nav">
                    <NavItem tag="div">
                      <NavLink tag={Link} to="/">
                        <i className="far fa-tachometer-alt-fast" />
                        {intl.formatMessage({ defaultMessage: 'Dashboard' })}
                      </NavLink>
                    </NavItem>
                    <NavItem tag="div">
                      <NavLink tag={Link} to="/accounts">
                        <i className="far fa-file-user" />
                        {intl.formatMessage({ defaultMessage: 'Accounts' })}
                      </NavLink>
                    </NavItem>
                  </div>
                </Nav>
                <p className="stockpress-version">
                  <Link to="/changelog">
                    {version.version} ({version.gitBranch ? `${version.gitBranch}-` : ''}{version.gitHash})
                  </Link>
                </p>
              </TabPane>
            </TabContent>
          </div>
        </nav>
      </>
    );
  }
}

const mapStateToProps = state => ({
  version: state.App.version,
  profile: state.Auth.profile,
  filters: state.Files.filters,
  featuredCollections: state.Collections.featuredCollections,
  featuredCollectionsLoading: state.Collections.featuredCollectionsLoading,
  collectionFilters: state.Collections.filters,
});

AdminPanelSidebar.propTypes = {
  intl: PropTypes.object.isRequired,
  version: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps)(injectIntl(AdminPanelSidebar)));
